import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";
import AbsenceStatusIcon from "./AbsenceStatusIcon";
import "./AbsencesFilters.css";
import {
	switchAbsenceMode,
	setStatusFilter,
	getStatusList,
	getStatusLabel,
} from "../../redux/absences/absencesActions";
import { ALL_SELECT_OPTION } from "../../constants";
import { InputLabel } from "@mui/material";
import CustomizedSelect from "../Input/CustomizedSelect";
import Button from '@mui/material/Button';

class AbsencesFilters extends Component {
	constructor(props) {
		super(props);
		this.state = {
			statusList: getStatusList(),
			open: false
		};
	}

	handleClick() {
		this.setState({
		  open: !this.state.open,
		});
	}

	toggleArrow = () => {
		return this.state.open ? (
			<i className="material-icons">
			keyboard_arrow_up
			</i>
		) : (
			<i className="material-icons">
			keyboard_arrow_down
			</i>
		);
	}

	switchAbsenceModeHandler() {
		this.props.switchAbsenceMode(this.props.absences.absencesToValidateMode, this.props.activeUser);
	}

	statusFilterChange(e) {
		this.props.setStatusFilter(e.target.value);
	}

	render() {
		let rowsStatusList = [
			<MenuItem key={0} value={ALL_SELECT_OPTION}>
				{"Tous"}
			</MenuItem>,
		];
		for (let i = 1; i < this.state.statusList.length + 1; i++) {
			let currentStatus = this.state.statusList[i - 1];

			rowsStatusList.push(
				<MenuItem key={i} value={currentStatus}>
					<div className="row">
						<AbsenceStatusIcon
							key={"status-icon"}
							className="absence-icon without-side-padding"
							status={currentStatus}
						/>
						&nbsp; - &nbsp;
						{getStatusLabel(currentStatus)}
					</div>
				</MenuItem>
			);
		}

		return (
			<div>
				<div className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
					<Button
						color="primary"
						onClick={this.handleClick.bind(this)}
						variant="contained"
						style={{marginBottom: '10px', marginLeft: '15px'}}
					>
						<i className="material-icons">
						<span>filter_list</span>
						</i>
						<span
						>
						Filtres
						</span>
						{this.toggleArrow()}
					</Button>
				</div>
				{ this.state.open ? 
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 row sub-header without-side-padding">
						<div className="col-lg-6 col-md-6 col-sm-12 col-12 without-side-padding">
							<div className="row without-side-padding switch-label">
								<div className="offset-lg-2 col-lg-3 offset-md-1 col-md-4 col-sm-4 col-4 right span-center-verticaly medium-grey-text without-side-padding">
									<span className={!this.props.absences.absencesToValidateMode ? "selected-label" : ""}>
										Mes absences
									</span>
								</div>
								<div className="col-lg-2 col-md-2 col-sm-4 col-4 without-side-padding">
									<Switch
										onChange={this.switchAbsenceModeHandler.bind(this)}
										checked={this.props.absences.absencesToValidateMode}
										className="switch"
										color="default"
										value={"absencesToValidate"}
										label={"Absences à valider"}
									/>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-4 col-4 medium-grey-text without-side-padding span-center-verticaly">
									<span className={this.props.absences.absencesToValidateMode ? "selected-label" : ""}>
										Absences à valider
									</span>
								</div>
							</div>
						</div>
						<div className="offset-lg-2 col-lg-3 offset-md-1 col-md-4 col-sm-12 col-12 without-side-padding">
							<div className="col-lg-12 col-md-12 offset-sm-2 col-sm-8 col-12 control-margin-top">
								<div className="row sub-header">
									<div>
										<FormControl className="col-lg-12 col-md-12 col-sm-12 col-12">
										
											<InputLabel id="status-filter-label" className="placeholder-select-light-background" sx={{color: "#333333 !important"}}>Statut</InputLabel>
											<CustomizedSelect
												label="Statut"
												labelId="status-filter-label"
												id="status-filter"
												inputProps={{ name: "status-filter", id: "status-filter" }}
												placeholder="Statut"
												className="full_size select-light-background"
												menuclasses="select-popup"
												onChange={this.statusFilterChange.bind(this)}
																				value={this.props.absences.absencesStatusFilter}
											>
												{rowsStatusList}
											</CustomizedSelect>
										</FormControl>
									</div>
								</div>
							</div>
						</div>
					</div>
				: null}
			</div>
			
		);
	}
}

const mapStateToProps = (state) => {
	return {
		absences: state.absences,
		activeUser: state.activeUser,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setStatusFilter: (statusFilter) => dispatch(setStatusFilter(statusFilter)),
		switchAbsenceMode: (currentMode, activeUser) => dispatch(switchAbsenceMode(currentMode, activeUser)),
	};
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AbsencesFilters);
